import React, { Component, useContext, useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { Form } from "react-bootstrap";
import Logo from "../assets/img/logo_main.png";
import {
  onAuthStateChanged,
  signOut,
  signInWithEmailAndPassword,
} from "firebase/auth";
import { auth } from "../firebase/firebase-config";
import { useAuthState } from "react-firebase-hooks/auth";
import "react-toastify/dist/ReactToastify.css";
import { toast, Toast, ToastContainer } from "react-toastify";
import firebase from "../firebase/firebase-config";
import { GoogleLogin, GoogleLogout } from "react-google-login";
import { gapi } from "gapi-script";
import Loading from "../components/Loader/Loading";
import { GoogleLoginContext } from "../contexts/GoogleLoginContext";

// const navigate = useNavigate();
function Login() {
  let history = useHistory();
  const { setToken, ProfileAdded } = useContext(GoogleLoginContext);

  const [loginPassword, setloginPassword] = useState("");
  const [user, setuser] = useState({});
  const [authUser, settloading] = useAuthState(auth);

  const [EmailLogin, setEmailLogin] = useState("");

  const [authenticated, setauthenticated] = useState(
    localStorage.getItem(localStorage.getItem("authenticated") || false)
  );
  const [loading, setLoading] = useState(false);

  const login = async () => {
    try {
      setLoading(true);
      const user = await signInWithEmailAndPassword(
        auth,
        EmailLogin,
        loginPassword
      );

      console.log(user);

      setLoading(false);

      const this_user = await firebase
        .firestore()
        .collection("admins")
        .doc(user.user?.uid)
        .get();

      console.log(this_user.data());
      if (this_user.data() == undefined) {
        toast.warning("User is not admin", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
        signOut(auth);
      }

      // if (this_user.data()["isActive"] == true) {
      // console.log();

      setauthenticated(true);

      localStorage.setItem("authenticated", true);
      localStorage.setItem("user_id", user.user?.uid);
      console.log("logged in");
      // toast.success("User Has been logged in Successfully!", {
      //   position: "top-right",
      //   autoClose: 5000,
      //   hideProgressBar: false,
      //   closeOnClick: true,
      //   pauseOnHover: true,
      //   draggable: true,
      //   progress: undefined,
      //   theme: "dark",
      // });
      ProfileAdded(user?.user);
      setToken(user?.user?.accessToken);
      history.push("/admin/dashboard");
      // history.push("/Google-Analytics-connect");
      // }
    } catch (error) {
      console.log(error.message);
      switch (error.code) {
        case "auth/Invalid-email":
        case "auth/user-disabled":
        case "auth/user-not-found":
          toast.warning("This Email is Invalid/User not found.", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "dark",
          });
          break;
        case "auth/wrong-password":
          toast.warning("You have entered an incorrect Email/Password", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "dark",
          });
          break;
        case "auth/internal-error":
          toast.warning("Please enter correct credentials/internal error.", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "dark",
          });
          break;
        case "auth/too-many-requests":
          toast.warning(
            "Access to this account has been temporarily disabled due to many failed login attempts. You can immediately restore it by resetting your password or you can try again later.",
            {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "dark",
            }
          );
          break;
        default:
      }
    }
  };

  // useEffect(() => {
  //   async function authfunc() {
  //     if (authUser) {
  //       const this_user = await firebase
  //         .firestore()
  //         .collection("admins")
  //         .doc(authUser?.uid)
  //         .get();
  //       if (this_user.data() == undefined) {
  //         signOut(auth);
  //         history.push("/Login");
  //       }

  //       if (this_user.data()["isActive"] == true) {

  //       }
  //     } else {
  //       history.push("/Login");
  //     }
  //   }
  //   authfunc();
  // }, [authUser]);

  const EmailVal = (e) => {
    setEmailLogin(e.target.value);
  };

  // useEffect(() => {
  //   setTimeout(() => setLoading(false), 3300)
  // }, [])
  if (loading) {
    return <Loading />;
  }
  return (
    <div>
      <div className="d-flex align-items-center  justify-content-center auth px-0 ">
        <div className="d-flex   align-items-center ">
          {/* <div className="col-lg-4 mx-auto"> */}
          <div className="auth-form-light  justify-content-center text-left py-5 mt-5 px-4 px-sm-5 shadow-lg">
            <div className="d-flex justify-content-center">
              <img src={Logo} alt="logo" />
            </div>
            {/* <h4>Hello! let's get started</h4> */}
            <h6 className="font-weight-light mt-3">Sign in to continue.</h6>
            {user?.email}
            <Form
              onSubmit={(e) => {
                e.preventDefault();
              }}
              className="pt-2"
            >
              <Form.Group className="d-flex flex-column search-field">
                <h4>Username</h4>
                <Form.Control
                  type="email"
                  placeholder="Username"
                  size="lg"
                  value={EmailLogin}
                  className="h-auto p-2 "
                  onChange={EmailVal}
                />
                {/* onChange={(e) => { setloginEmail(e.target.value) }} */}
              </Form.Group>
              <Form.Group className="d-flex flex-column search-field">
                <h4 className="mt-2">Password</h4>
                <Form.Control
                  type="password"
                  placeholder="Password"
                  value={loginPassword}
                  size="lg"
                  onChange={(e) => {
                    setloginPassword(e.target.value);
                  }}
                  className="h-auto p-2"
                />
                {/*  */}
              </Form.Group>
              <div className="mt-3">
                <button
                  className="btn btn-block btn-primary btn-lg font-weight-medium auth-form-btn"
                  onClick={login}
                >
                  SIGN IN
                </button>
              </div>
              {/* <div className="my-2 d-flex justify-content-between align-items-center">
                <div className="form-check">
                  <label className="form-check-label text-muted">
                    <input type="checkbox" className="form-check-input" />
                    <i className="input-helper"></i>
                    Keep me signed in
                  </label>
                </div>
                <a href="!#" className="auth-link text-black">Forgot password?</a>
              </div> */}
              <div className="mb-2 d-flex justify-content-center">
                {/* <button type="button" className="btn btn-block" style={{ backgroundColor: 'orange', background: 'linear - gradient(rgba(250, 0, 0, 0.5), transparent)' }}>
                  <i className=" mr-2"></i>Connect using Google
                </button> */}
              </div>
              {/* <div className="text-center mt-4 font-weight-light">
                Don't have an account? <Link to="/user-pages/register" className="text-primary">Create</Link>
              </div> */}
            </Form>
          </div>
        </div>
      </div>
      {/* </div> */}
      <ToastContainer />
    </div>
  );
}

export default Login;
